import React from "react";
import { CorePanhandlePlansName, CorePlansName, VEB_PLAN_ARRAY } from "../../../../constants/plan";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";
import { Button, IconButton } from "@mui/material";
import { FaInfoCircle } from "react-icons/fa";
import { HiOutlinePencilSquare } from "react-icons/hi2";

import { enrollmentInfoGridProps } from "../../../../types/enrollmentV2.types";
import "./enrollmentInfo.css";
import { GROUP_NUMBER } from "../../../../constants/groups";
const EnrollmentInfoGrid: React.FC<enrollmentInfoGridProps> = ({
	plan_code,
	plan_name,
	sub_plan,
	enrollment_date,
	initial_effective_date,
	effective_date,
	benefit_end_date,
	termination_date,
	coreDependentsCount,
	vebDependentsCount,
	coreTrueCount,
	vebTrueCount,
	vebRiderCount,
	handleClick,
	handleVebRiderMenuClick,
	enrollmentsLength,
	enrollments,
	handleVebBeneficiaryMenuClick,
	handleOpenCloseEditBeneficiaryModal
}) => {
	const isPanhandle = enrollments[0].group_number === GROUP_NUMBER.BOP_PANHANDLE_FIRST_BANK;
	const isCorePlan =
		CorePlansName.includes(plan_name) ||
		(enrollments.length > 0 && isPanhandle && CorePanhandlePlansName.includes(plan_name));

	const isVebPlan = VEB_PLAN_ARRAY.includes(plan_name);

	const filteredBenificaryLength = enrollments.filter(
		// eslint-disable-next-line arrow-parens
		(enrollment: { VEB_primary_beneficiary: string[] }) =>
			enrollment.VEB_primary_beneficiary && enrollment.VEB_primary_beneficiary.length >= 1
	).length;

	// // console.log("enrollmwnt--------->", enrollments);

	// console.log("==TestCount==>", coreTrueCount, vebTrueCount, vebRiderCount, coreDependentsCount, vebDependentsCount);
	return (
		<div className="enrollment-info">
			<div className="enrollment-grid">
				<div className="field-column">
					{isVebPlan && (
						<div className="field">
							<span className="title">Coverage Level:</span>
						</div>
					)}
					{plan_name === CorePanhandlePlansName[0] && isPanhandle && (
						<div className="field">
							<span className="title">Sub Plan:</span>
						</div>
					)}
					<div className="field">
						<span className="title">Enrollment Date:</span>
					</div>
					<div className="field">
						<span className="title">Initial Effective Date:</span>
					</div>
					<div className="field">
						<span className="title">Effective Date:</span>
					</div>
					<div className="field">
						<span className="title">Benefit End Date:</span>
					</div>
					<div className="field">
						<span className="title">Covered Dependents:</span>
					</div>
					{isVebPlan && (
						<div className="field">
							<span className="title">Rider:</span>
						</div>
					)}
					{plan_name === CorePanhandlePlansName[0] && isPanhandle && (
						<div className="field">
							<span className="title">Rider:</span>
						</div>
					)}
					{isVebPlan && (
						<div className="field">
							<span className="title">Beneficiary:</span>
						</div>
					)}
				</div>
				<div className="value-column">
					{isVebPlan && (
						<div className="value">
							<span>{sub_plan ? sub_plan : "N/A"}</span>
						</div>
					)}
					{plan_name === CorePanhandlePlansName[0] && isPanhandle && enrollmentsLength > 0 && (
						<div className="value">
							<span>{sub_plan || enrollments[0].sub_plan || "N/A"}</span>
						</div>
					)}
					<div className="value">
						<span>{dateTimeZoneConverter(enrollment_date)}</span>
					</div>
					<div className="value">
						<span>
							{initial_effective_date
								? dateTimeZoneConverter(initial_effective_date)
								: dateTimeZoneConverter(effective_date)}
						</span>
					</div>
					<div className="value">
						<span>{dateTimeZoneConverter(effective_date)}</span>
					</div>
					<div className="value">
						{/* <span>{benefit_end_date ? dateTimeZoneConverter(benefit_end_date) : "Current"}</span> */}
						<span>{termination_date ? dateTimeZoneConverter(termination_date) : "Current"}</span>
					</div>
					<div className="value">
						{isCorePlan ? (
							<span style={{ fontSize: 15 }}>
								{enrollmentsLength > 1 && coreTrueCount >= 1 ? coreDependentsCount : "N/A"}{" "}
								{enrollmentsLength > 1 && coreTrueCount >= 1 && (
									<IconButton onClick={handleClick}>
										<FaInfoCircle size={15} />
									</IconButton>
								)}
							</span>
						) : (
							<span style={{ fontSize: 15 }}>
								{enrollmentsLength > 1 && vebTrueCount >= 1 ? vebDependentsCount : "N/A"}{" "}
								{enrollmentsLength > 1 && vebTrueCount >= 1 && (
									<IconButton onClick={handleClick}>
										<FaInfoCircle size={15} />
									</IconButton>
								)}
							</span>
						)}
					</div>
					{isVebPlan && (
						<div className="value">
							<span style={{ fontSize: 15 }}>
								{vebRiderCount === 0 || !vebRiderCount ? (
									"N/A"
								) : (
									<>
										{vebRiderCount}
										<IconButton onClick={handleVebRiderMenuClick}>
											<FaInfoCircle size={15} />
										</IconButton>
									</>
								)}
							</span>
						</div>
					)}
					{plan_name === CorePanhandlePlansName[0] && isPanhandle && enrollmentsLength > 0 && (
						<div className="value">
							<span>{enrollments[0].is_telehealth === true ? "Teladoc Health Plan" : "N/A"}</span>
						</div>
					)}
					{isVebPlan && (
						<div className="value">
							<span style={{ fontSize: 15 }}>
								{filteredBenificaryLength === 0 ? (
									"N/A"
								) : (
									<>
										<IconButton onClick={handleOpenCloseEditBeneficiaryModal}>
											<FaInfoCircle size={18} />
										</IconButton>
									</>
								)}
							</span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default EnrollmentInfoGrid;
